<!--
  SoldOutPopup:F-5 门票售空 popup(UI-SPEC §4.7)
  简小 popup:标题 + 副标 + OK 按钮
  触发条件:提交后业务错 31003/31005(EVENT_INVALID / OUT_OF_STOCK)
-->
<template>
  <div class="sold-out-popup" :class="`page-${pageType}`">
    <h2 class="title">{{ t('Modal.soldOutTitle') }}</h2>
    <p class="subtitle">{{ t('Modal.soldOutSubtitle') }}</p>
    <button
      type="button"
      class="btn-primary"
      @click="$emit('ok')"
    >
      {{ t('Modal.ok') }}
    </button>
  </div>
</template>

<script lang="ts">
import t from '../utils/i18n';
type Props = {
  pageType: 'PC' | 'H5';
};
const __sfc_main = {};
__sfc_main.props = {
  pageType: {
    key: "pageType",
    required: true,
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  return {
    t
  };
};
export default __sfc_main;
</script>

<style scoped>
.sold-out-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.btn-primary {
  background: #ff6900;
  color: #ffffff;
  border: none;
  cursor: pointer;
}

/* ─── H5(rem)UI-SPEC §4.7 ─────────────────────────────── */
.page-H5 {
  padding: 0.4rem;
  gap: 0.4rem;
}
.page-H5 .title {
  font-weight: 520;
  font-size: 0.4231rem;
  color: #0f1112;
  margin: 0;
  text-align: center;
}
.page-H5 .subtitle {
  font-weight: 400;
  font-size: 0.3rem;
  color: #626262;
  margin: 0;
  text-align: center;
}
.page-H5 .btn-primary {
  width: 4.5rem;
  height: 0.9rem;
  border-radius: 2rem;
  font-weight: 600;
  font-size: 0.36rem;
}

/* ─── PC UI-SPEC §4.7 ────────────────────────────────── */
.page-PC {
  gap: 20px;
}
.page-PC .title {
  font-weight: 600;
  font-size: 28px;
  color: #000000;
  margin: 0;
  text-align: center;
}
.page-PC .subtitle {
  font-weight: 400;
  font-size: 18px;
  color: #626262;
  margin: 0;
  text-align: center;
}
.page-PC .btn-primary {
  width: 280px;
  height: 60px;
  border-radius: 60px;
  font-weight: 600;
  font-size: 24px;
}
</style>
